import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  IconSettings,
  Modal,
} from '@salesforce/design-system-react';

import AstroWelcome from '../../Components/Entry/AstroWelcome';
import JourneyTable from '../../Components/Entry/JourneyTable';
import JourneyModal from '../../Components/Entry/JourneyModal';
import ConfirmActionModal from '../../Components/App/ConfirmActionModal';
import WelcomeMatModal from '../../Components/Entry/WelcomeMatModal';
import QuipGeneration from '../../Components/App/QuipGeneration';
import CustomToastContainer from '../../Components/App/CustomToastContainer';
import VidyardEmbed from '@vidyard/embed-code';
import CollaboratorTable from '../../Components/Entry/CollaboratorTable';
import CollaboratorModal from '../../Components/Entry/CollaboratorModal';
import EntrySidebar from '../../Components/Sidebars/Entry/EntrySidebar';
import { socket } from '../../socket';
import SocketListeners from '../../Components/App/SocketListeners';
import {
  storeJourneyId,
  startJourney,
  deleteJourneyAndRelated,
  loadJourneysFromDB,
  addQuipAccessToken,
  createQuip,
  createSlides,
  createStageMap,
  purge,
  searchOpps,
  searchCollaborators,
  setIsCollaborator,
  loadJourneyAndRelated,
  storeChecklistDB,
  setSlidesLoading,
  setStageMapLoading,
  addJourneyCollaborators,
  addingActiveCollab
} from '../../actions';


class Entry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      goToBusinessChallenge: false,
      astro: false,
      isOpen: false,
      isQuipModalOpen: false,
      isSlidesModalOpen: false,
      isStageMapModalOpen: false,
      isCollaboratorModalOpen: false,
      isDeleteModalOpen: false,
      isBeta: true,
      isWelcomeMatOpen: true,
      progress: 0,
      
    };
  }

  componentDidMount() {
    // render all players from placeholder images in the document
    VidyardEmbed.api.renderDOMPlayers();
    this.props.purge();
    this.props.loadJourneysFromDB();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.quipLink !== this.props.quipLink && this.props.quipLink) {
      window.open(this.props.quipLink, '_blank');
    }

    if (
      prevProps.slidesLink !== this.props.slidesLink &&
      this.props.slidesLink
    ) {
      window.open(this.props.slidesLink, '_blank');
    }
  }

  toggleQuipModalOpen = () => {
    this.setState({ isQuipModalOpen: !this.state.isQuipModalOpen });
  };
  toggleSlidesModalOpen = () => {
    this.setState({ isSlidesModalOpen: !this.state.isSlidesModalOpen });
  };

  toggleStageMapModalOpen = () => {
    this.setState({ isStageMapModalOpen: !this.state.isStageMapModalOpen });
  };

  toggleCollaboratorModalOpen = () => {
    this.setState({
      isCollaboratorModalOpen: !this.state.isCollaboratorModalOpen,
    });
  };

  toggleDeleteConfirm = () => {
    this.setState({ isDeleteModalOpen: !this.state.isDeleteModalOpen });
  };
  toggleWelcomeMatOpen = () => {
    this.setState({ isWelcomeMatOpen: !this.state.isWelcomeMatOpen });
  };

  generateQuip = () => {
    if (this.props.journeyId && this.props.quipAccessToken) {
      this.props.createQuip(this.props.quipAccessToken, this.props.journeyId);
    }
  };

  generateSlides = (color, logo, email) => {
    this.props.createSlides(this.props.journeyId, color, logo, email);
  };

  updateChecklistOne = () => {
    if (this.props.checklistOne === false) {
      this.props.storeChecklistOneDB(this.props.journeyId, true);

      let prog = this.state.progress + 75;

      this.setState({ progress: prog });
    }
  };

  updateChecklistTwo = () => {
    if (this.props.checklistTwo === false) {
      this.props.storeChecklistTwoDB(this.props.journeyId, true);

      let prog = this.state.progress + 25;

      this.setState({ progress: prog });
    }
  };

  showAstro = () => {
    this.setState(() => ({
      astro: true,
    }));
  };

  closeAstro = () => {
    this.setState({
      astro: null,
      progress: 0,
    });
  };

  nextScreen = () => {
    this.props.history.push('/');
    this.setState({
      astro: null,
      goToBusinessChallenge: true,
    });
  };

  createJourney = async (journeyInfo) => {
    this.setState({ isOpen: false });

    await this.props.setIsCollaborator(false);
    await this.props.startJourney(journeyInfo);
    await this.props.storeChecklistOneDB(this.props.journeyId, false);
    await this.props.storeChecklistTwoDB(this.props.journeyId, false);

    this.showAstro();
  };

  handleJourneyDropdown = async (row, action, isLoadingCollaborator) => {
    switch (action.value) {
      case 'update_collaborator':
        // Need to send email with this
        await this.updateJourney(row.id);
        await this.props.setIsCollaborator(true);
        break;
      case 'edit':
        break;
      case 'slides':
        await this.props.storeJourneyId(row.id);
        this.toggleSlidesModalOpen();
        break;
      case 'stage-map':
        await this.props.storeJourneyId(row.id);
        this.toggleStageMapModalOpen();
        break;
      case 'delete':
        await this.props.storeJourneyId(row.id);
        this.toggleDeleteConfirm();
        break;
      default:
        break;
    }
  };

  updateJourney = async (journeyId) => {
    if (!Number.isNaN(parseInt(journeyId))) {
      await this.props.loadJourneyAndRelated(journeyId); // query who exists in room.
      socket.emit('onLoadServer', this.props.journeyId);

      if (this.props.checklistOne && this.props.checklistTwo) {
        this.setState({ goToBusinessChallenge: true });
      } else {
        if (this.props.checklistOne) this.setState({ progress: 75 });
        else if (this.props.checklistTwo) this.setState({ progress: 25 });

        this.showAstro();
      }
    } else {
      console.log('THROW ERROR NO JOURNEY SELECTED');
    }
  };

  deleteJourney = (journeyId) => {
    if (!Number.isNaN(parseInt(journeyId))) {
      this.props.deleteJourneyAndRelated(journeyId);
      this.setState({ isDeleteModalOpen: false });
    }
  };

  addCollaborators = async (collaboratorInfo) => {
    if (!Number.isNaN(parseInt(collaboratorInfo.journeyId))) {
      await this.props.addJourneyCollaborators(
        collaboratorInfo.collaborators,
        collaboratorInfo.journeyId,
        collaboratorInfo.pillOptions
      );
      this.setState({ isCollaboratorModalOpen: false });
    }
  };

  render() {
    if (this.state.goToBusinessChallenge) {
      let url = '/BusinessChallenge';
      switch (this.props.stepId) {
        case 2:
          url = '/Personas';
          break;
        case 3:
          url = '/Milestones';
          break;
        case 4:
          url = '/MilestoneConnectors';
          break;
        case 5:
          url = '/ProductsOverlay';
          break;
        default:
          break;
      }

      window.scrollTo(0, 0);

      return <Redirect to={{ pathname: url }} />;
    }

    return (
      <IconSettings iconPath="/icons">
        <SocketListeners />
        <CustomToastContainer />
        {this.state.astro ? (
          <AstroWelcome
            isCollaborator={this.props.isCollaborator}
            checklistOne={this.props.checklistOne}
            checklistTwo={this.props.checklistTwo}
            updateChecklistOne={() => this.updateChecklistOne()}
            updateChecklistTwo={() => this.updateChecklistTwo()}
            closeAstro={() => this.closeAstro()}
            nextScreen={() => this.nextScreen()}
            progress={this.state.progress}
          />
        ) : null}
        <WelcomeMatModal
          isOpen={this.state.isWelcomeMatOpen}
          toggleWelcomeMat={this.toggleWelcomeMatOpen}
        />
        <JourneyModal
          isOpen={this.state.isOpen}
          toggleOpen={() => this.setState({ isOpen: !this.state.isOpen })}
          journeyEmail={this.props.username}
          opps={this.props.opps || []}
          isLoading={this.props.isLoadingOpps}
          onChange={(e) => this.props.searchOpps(e)}
          collaborator={this.props.searchedCollaborators || []}
          isLoadingCollaborator={this.props.isLoadingSearchedCollaborators}
          onCollaboratorsChange={(e) => this.props.searchCollaborators(e)}
          onSubmit={(e) => this.createJourney(e)}
        />
        <ConfirmActionModal
          isOpen={this.state.isDeleteModalOpen}
          toggleOpen={() => this.toggleDeleteConfirm()}
          onSubmit={() => this.deleteJourney(this.props.journeyId)}
          heading="Delete Journey"
        >
          <div className="slds-text-align_center slds-m-around_medium slds-text-color_destructive">
            <strong>Are you sure you want to delete this journey?</strong>
          </div>
        </ConfirmActionModal>

        <Modal
          isOpen={this.state.isQuipModalOpen}
          onRequestClose={this.toggleQuipModalOpen}
          heading="Generate Quip"
        >
          <QuipGeneration
            onSave={this.generateQuip}
            error={this.props.quipError}
            isLoading={this.props.isQuipLoading}
            quipToken={this.props.quipAccessToken}
            onQuipChange={(e) => this.props.addQuipAccessToken(e.target.value)}
          />
        </Modal>

        <Modal
          isOpen={this.state.isCollaboratorModalOpen}
          onRequestClose={this.toggleCollaboratorModalOpen}
          heading="Add Collaborators"
        >
          <CollaboratorModal
            journeyId={this.props.journeyId}
            journeyEmail={this.props.username}
            isLoadingCollaborator={this.props.isLoadingCollaborator}
            onCollaboratorsChange={(e) => this.props.searchCollaborators(e)}
            collaborator={this.props.searchedCollaborators || []}
            onSubmit={(e) => this.addCollaborators(e)}
          />
          
        </Modal>
        <EntrySidebar />
        <div>
          <div style={{ marginLeft: 'max(220px, 15%)'}} className="slds-p-horizontal_x-large">
              <div className="slds-p-vertical_medium">
                <JourneyTable
                  items={this.props.journeys}
                  isBeta={this.state.isBeta}
                  handleRowAction={this.handleJourneyDropdown}
                  startJourney={() =>
                    this.setState({ isOpen: !this.state.isOpen })
                  }
                  updateJourney={async (id) => {
                    await this.updateJourney(id);
                    await this.props.setIsCollaborator(false);
                  }}
                  addCollaborators={async(id) => {
                    await this.props.storeJourneyId(id);
                    this.toggleCollaboratorModalOpen();
                  }}
                  generateQuip={async(id) => {
                    await this.props.storeJourneyId(id);
                    this.toggleQuipModalOpen();
                  }}
                  deleteJourney={async(id) => {
                    await this.props.storeJourneyId(id);
                    this.toggleDeleteConfirm();
                  }}
                />
              </div>
              <div className="slds-p-vertical_medium">
                <CollaboratorTable
                  items={this.props.collaboratorJourneys}
                  handleRowAction={this.handleJourneyDropdown}
                />
              </div>
            </div>
        </div>
      </IconSettings>
    );
  }
}

const mapStateToProps = (state) => ({
  journeys: state.app.journeys.map((jry) => {
    let created = jry.created_at;
    try {
      created = new Date(jry.created_at).toLocaleDateString();
    } catch (e) {}

    return {
      ...jry,
      finished: jry.finished ? 'Complete' : 'In Progress',
      created,
    };
  }),
  collaboratorJourneys: state.collaborators.collaboratorJourneys.sort((a, b) => a.created_at < b.created_at ? 1 : -1).map(
    (journey) => {
      let created = journey.created_at;
      try {
        created = new Date(journey.created_at).toLocaleDateString();
      } catch (e) {}

      return {
        ...journey,
        journey_name: journey.journey_name,
        owner: journey.name,
        finished: journey.finished ? 'Complete' : 'In Progress',
        created,
      };
    }
  ),
  opps: state.app.opportunities.map((opp) => {
    return {
      label: opp.Name,
      id: opp.Id,
      subTitle: `${opp.Owner ? opp.Owner.Name : ''} • ${opp.value}`,
      value: opp.Id,
      industry: opp.Account.Industry,
    };
  }),
  searchedCollaborators: state.collaborators.collaborators.map(
    (collaborator) => {
      return {
        label: collaborator.name,
        id: collaborator.id,
        subTitle: collaborator.email,
        value: collaborator.id,
      };
    }
  ),
  username: state.app.username,
  isLoadingSlides: state.app.isLoadingSlides,
  isLoadingOpps: state.app.isLoadingOpps,
  isLoadingSearchedCollaborators: state.app.isLoadingSearchedCollaborators,
  journeyId: state.app.journeyId,
  checklistOne: state.app.checklistOne,
  checklistTwo: state.app.checklistTwo,
  stepId: state.app.stepIdStore,
  slidesLink: state.app.slidesLink,
  quipLink: state.quip.link,
  quipAccessToken: state.quip.accessToken,
  isQuipLoading: state.quip.isLoading,
  isSlidesLoading: state.app.isLoadingSlides,
  isStageMapLoading: state.app.isLoadingStageMap,
  quipError: state.quip.errorMessage,
  isCollaborator: state.collaborators.isCollaborator,
});

const mapDispatchToProps = (dispatch) => ({
  purge: () => dispatch(purge()),
  searchOpps: (term) => dispatch(searchOpps(term)),
  searchCollaborators: (term) => dispatch(searchCollaborators(term)),
  loadJourneysFromDB: () => dispatch(loadJourneysFromDB()),
  loadJourneyAndRelated: (journeyId) =>
    dispatch(loadJourneyAndRelated(journeyId)),
  deleteJourneyAndRelated: (journeyId) =>
    dispatch(deleteJourneyAndRelated(journeyId)),
  storeJourneyId: (journeyId) => dispatch(storeJourneyId(journeyId)),
  addQuipAccessToken: (quipAccessToken) =>
    dispatch(addQuipAccessToken(quipAccessToken)),
  createQuip: (quipToken, journeyId) =>
    dispatch(createQuip(quipToken, journeyId)),
  createSlides: (journeyId, color, logo, email) =>
    dispatch(createSlides(journeyId, color, logo, email)),
  startJourney: (journeyInfo) => dispatch(startJourney(journeyInfo)),
  storeChecklistOneDB: (journeyId, checklistOne) =>
    dispatch(storeChecklistDB(journeyId, 1, checklistOne)),
  storeChecklistTwoDB: (journeyId, checklistTwo) =>
    dispatch(storeChecklistDB(journeyId, 2, checklistTwo)),
  setIsCollaborator: (isCollaborator) =>
    dispatch(setIsCollaborator(isCollaborator)),
  setSlidesLoading: (isLoading) => dispatch(setSlidesLoading(isLoading)),
  setStageMapLoading: (isLoading) => dispatch(setStageMapLoading(isLoading)),
  createStageMap: (logo, email, journeyId, type) =>
    dispatch(createStageMap(logo, email, journeyId, type)),
  addJourneyCollaborators: (searchedCollaborators, journeyId, pillOptions) =>
    dispatch(
      addJourneyCollaborators(searchedCollaborators, journeyId, pillOptions)
    ),
    addingActiveCollab : (email) =>
    dispatch(addingActiveCollab(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Entry);
